"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _superSegments = require("../../reducers/superSegments");

var _actions = require("../../actions");

var _index = require("../../../index");

var _LandingPageCard = _interopRequireDefault(require("../../components/CampaignCreator/LandingPageCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var GettingStarted = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GettingStarted, _React$Component);

  function GettingStarted() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = GettingStarted.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.loadSuperSegments();
    this.props.featureAccess();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        communityImages = _this$props.communityImages,
        isFetching = _this$props.isFetching,
        firstLandingPage = _this$props.firstLandingPage,
        campaignCreatorAccess = _this$props.campaignCreatorAccess;

    if (isFetching && !communityImages) {
      return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, campaignCreatorAccess ? /*#__PURE__*/React.createElement(_semanticUiReact.Container, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "landing-page"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "landing-page__title"
    }, firstLandingPage ? firstLandingPage.pageTitle : null), /*#__PURE__*/React.createElement("h3", {
      className: "landing-page__sub-title"
    }, firstLandingPage ? firstLandingPage.subtitle : null), /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      className: "landing-page__inner-grid"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      columns: 4
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      to: "/campaign-creator/select-personas-new",
      communityImages: communityImages,
      blurred: false,
      title: "I'll select from the list"
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      to: "/campaign-creator/select-personas",
      communityImages: communityImages,
      blurred: false,
      title: firstLandingPage ? firstLandingPage.firstImageText : ''
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      to: "/campaign-creator/find-personas",
      communityImages: communityImages,
      blurred: true,
      title: firstLandingPage ? firstLandingPage.secondImageText : ''
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/React.createElement(_LandingPageCard["default"], {
      to: "/campaign-creator/find-personas-new",
      communityImages: communityImages,
      blurred: true,
      title: "I'll let the system select"
    })))))))) : '');
  };

  return GettingStarted;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    isFetching: state.superSegments.isFetching,
    communityImages: (0, _superSegments.getCommunityImages)(state),
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    firstLandingPage: state.campaignCreator.options.firstLandingPage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GettingStarted);

exports["default"] = _default;